import { Outlet, getRouteApi } from '@tanstack/react-router'
import { Page, PageFace } from 'ui/components/Page'
import { DocumentFooterActions } from '~bank-documents/components/DocumentFooterActions'
import { FilesSection } from '~bank-documents/components/FilesSection'

import { HistorySection } from './components/HistorySection'
import { PeriodInformation } from './components/PeriodInformation'

const PeriodDetails = () => {
  const routeApi = getRouteApi('/_app/documents/$documentId/periods/$periodId')
  const data = routeApi.useLoaderData()
  const periodId = routeApi.useParams({ select: (s) => s.periodId })

  return (
    <>
      <Page
        face={PageFace.SECONDARY}
        title="Document"
        subTitle={data.documentName}
        footerV2={
          <DocumentFooterActions
            id={Number(periodId)}
            flags={{
              showCanAccept: data?.showCanAccept,
              showCanIncomplete: data?.showCanIncomplete,
              showCanReject: data?.showCanReject,
              showNotes: data?.notes
            }}
          />
        }
      >
        <PeriodInformation />
        <FilesSection id={Number(periodId)} files={data.documentFiles} withDialog={data.isLastDelivery} />
        <HistorySection />
      </Page>
      <Outlet />
    </>
  )
}

export default PeriodDetails
